const BRAND_PREFIX_MAP: Record<string, string> = {
  WHIRL: 'W',
  MYTAG: 'M',
  KHAID: 'K',
  AMANA: 'A',
  JNAIR: 'J',
};

export const getModelSerialExamples = (brand?: string) => {
  const b = (brand || '').trim().toUpperCase();
  const prefix = BRAND_PREFIX_MAP[b] ?? 'W';
  const modelExample = `${prefix}ABC1234YZ`;
  const serialExample = 'E61201983';

  return {
    modelExample,
    serialExample,
    modelHintText: `For example ${modelExample}`,
    serialHintText: `For example ${serialExample}`,
  };
};
